import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { SelectionListHeaderComponent } from './selection-list-header.component';

@NgModule({
  declarations: [SelectionListHeaderComponent],
  imports: [
    CommonModule,
    MatListModule,
    MatCheckboxModule
  ],
  exports: [
    SelectionListHeaderComponent
  ]
})
export class SelectionListHeaderModule { }
